import slick from "slick-carousel";
window.jQuery = $;

$(document).ready(function () {

    //Next Races
    if ($("#slider-races").hasClass('slick-initialized')) {
        $(this).slick('unslick');
    }

    $("#slider-races").slick({
        dots: false,
        infinite: false,
        speed: 300,
        margin: 105,
        slidesToShow: 3,
        adaptiveHeight: true,
        variableWidth: true,
        arrows: true,
        prevArrow: $('#prev-arrow-races'),
        nextArrow: $('#next-arrow-races'),
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            }
        ]
    });

    //Cars
    if ($("#slider-cars").hasClass('slick-initialized')) {
        $(this).slick('unslick');
    }

    $("#slider-cars").slick({
        dots: true,
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        arrows: false,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    dots: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            }
        ]
    });

    //Partners
    if ($("#slider-partners").hasClass('slick-initialized')) {
        $(this).slick('unslick');
    }

    $("#slider-partners").slick({
        dots: false,
        infinite: false,
        speed: 300,
        slidesToShow: 6,
        arrows: true,
        cssEase: 'linear',
        prevArrow: $('#prev-arrow-partners'),
        nextArrow: $('#next-arrow-partners'),
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 7,
                    slidesToScroll: 1,
                    variableWidth: true
                }
            },
            {
                breakpoint: 810,
                settings: {
                    slidesToShow: 6,
                    slidesToScroll: 1,
                    variableWidth: true
                }
            },
            {
                breakpoint: 690,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 1,
                    variableWidth: true
                }
            },
            {
                breakpoint: 580,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    variableWidth: true
                }
            },
            {
                breakpoint: 470,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    variableWidth: true
                }
            }
        ]
    });

    //Latest news
    if ($("#slider-latest-news").hasClass('slick-initialized')) {
        $(this).slick('unslick');
    }

    $("#slider-latest-news").slick({
        responsive: [
            {
                breakpoint: 9999,
                settings: "unslick"
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    variableWidth: true,
                    speed: 300,
                    infinite: false,
                    dots: false,
                    arrows: false,

                }
            },
            {
                breakpoint: 835,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    variableWidth: true,
                    speed: 300,
                    infinite: false,
                    dots: false,
                    arrows: false,

                }
            },
            {
                breakpoint: 560,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    variableWidth: true,
                    speed: 300,
                    infinite: false,
                    dots: false,
                    arrows: false,

                }
            },
        ]
    });

    //Products
    if ($("#slider-products").hasClass('slick-initialized')) {
        $(this).slick('unslick');
    }

    $("#slider-products").slick({
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        arrows: true,
        fade: true,
        cssEase: 'linear',
        prevArrow: $('#prev-arrow-products'),
        nextArrow: $('#next-arrow-products'),
    });

    $('#slider-products').on('afterChange', function() {
        let dataId = $(this).find('.slick-current').attr("data-slick-index"); 
        $('#products-current-slide').html('0' + (parseInt(dataId) + 1));  
    });

    //Other news
    if ($("#slider-other-news").hasClass('slick-initialized')) {
        $(this).slick('unslick');
    }

    $("#slider-other-news").slick({
        responsive: [
            {
                breakpoint: 9999,
                settings: "unslick"
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    variableWidth: true,
                    speed: 300,
                    infinite: false,
                    dots: false,
                    arrows: false,

                }
            },
            {
                breakpoint: 835,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    variableWidth: true,
                    speed: 300,
                    infinite: false,
                    dots: false,
                    arrows: false,

                }
            },
            {
                breakpoint: 560,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    variableWidth: true,
                    speed: 300,
                    infinite: false,
                    dots: false,
                    arrows: false,

                }
            },
        ]
    });

    //Other news
    if ($("#slider-related-products").hasClass('slick-initialized')) {
        $(this).slick('unslick');
    }

    $("#slider-related-products").slick({
        responsive: [
            {
                breakpoint: 9999,
                settings: "unslick"
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 1,
                    variableWidth: true,
                    speed: 300,
                    infinite: false,
                    dots: false,
                    arrows: false,

                }
            },
            {
                breakpoint: 835,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    variableWidth: true,
                    speed: 300,
                    infinite: false,
                    dots: false,
                    arrows: false,

                }
            },
            {
                breakpoint: 560,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    variableWidth: true,
                    speed: 300,
                    infinite: false,
                    dots: false,
                    arrows: false,

                }
            },
        ]
    });

    //Race drivers
    if ($("#slider-race-drivers").hasClass('slick-initialized')) {
        $(this).slick('unslick');
    }

    $("#slider-race-drivers").slick({
        responsive: [
            {
                breakpoint: 9999,
                settings: "unslick"
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    variableWidth: true,
                    speed: 300,
                    infinite: false,
                    dots: false,
                    arrows: false,

                }
            },
            {
                breakpoint: 835,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    variableWidth: true,
                    speed: 300,
                    infinite: false,
                    dots: false,
                    arrows: false,

                }
            },
            {
                breakpoint: 560,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    variableWidth: true,
                    speed: 300,
                    infinite: false,
                    dots: false,
                    arrows: false,

                }
            },
        ]
    });

});